// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"8d737d39","458":"ca3ab799","818":"40ff58eb"}[chunkId] + ".chunk.css";
};